import { render, staticRenderFns } from "./plateInput.vue?vue&type=template&id=08fda33e&scoped=true&"
import script from "./plateInput.vue?vue&type=script&lang=js&"
export * from "./plateInput.vue?vue&type=script&lang=js&"
import style0 from "./plateInput.vue?vue&type=style&index=0&id=08fda33e&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08fda33e",
  null
  
)

component.options.__file = "plateInput.vue"
export default component.exports